// extracted by mini-css-extract-plugin
module.exports = {"anchor":"anchor--1fyMJ","anchorText":"anchorText--wFIVC"};